import { FormGroup, FormLabel, MenuItem, Select, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import Grid from '@mui/material/Unstable_Grid2';
import { TemplateData } from "../../../types";
import { useState } from "react";

interface DailyScheduleBoxProps {
  template: TemplateData;
  setTemplate: (val: TemplateData) => void;
}

export const DailyScheduleBox = ({ template,  setTemplate }: DailyScheduleBoxProps) => {
  const days = [
    "1", "2", "3", "4", "5", "6", "7", "8", "9", "10",
    "11", "12", "13", "14", "15",
  ]

  return (
    <Stack spacing={2}>
      <FormGroup>
        <FormLabel>Every</FormLabel>
        <Stack direction="row" alignItems="center">
          <Select 
            value={template.schedule?.repeat_period?.every_days ?? ''}
            onChange={(e: any) => setTemplate({ ...template, schedule: { ...template.schedule ?? {}, repeat_period: { every_days: e.target.value } } })}
            sx={{ width: '100px', marginRight: '10px' }}
          >
            {
              days.map((day, index) => (
                <MenuItem key={index} value={day}>{day}</MenuItem>
              ))
            }
          </Select>
          <Typography>day/s</Typography>
        </Stack>
      </FormGroup>
      <FormGroup>
        <FormLabel>(Or) every</FormLabel>
        <ToggleButtonGroup
          color="primary"
          value={template.schedule?.repeat_period?.every_day_of_week ?? []}
          onChange={(e: any, val: string[]) => setTemplate({ ...template, schedule: { ...template.schedule ?? {}, repeat_period: { every_day_of_week: val } } })}
        >
          <Grid container spacing={1}>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="monday">Mon</ToggleButton></Grid>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="tuesday">Tue</ToggleButton></Grid>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="wednesday">Wed</ToggleButton></Grid>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="thursday">Thu</ToggleButton></Grid>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="Friday">Fri</ToggleButton></Grid>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="saturday">Sat</ToggleButton></Grid>
            <Grid xs={12/7}><ToggleButton sx={{ width: '100%' }} value="sunday">Sun</ToggleButton></Grid>
          </Grid>
        </ToggleButtonGroup>
      </FormGroup>
    </Stack>
  )
}